import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IFormButtonUi } from 'components/form-button/model';
import { Observable } from 'rxjs';

import { DynamicFormService } from 'common/dynamic-form/dynamic-form.service';
import { HiddenService } from 'common/dynamic-form/services/hidden.service';

@Component({
  selector: 'isp-field-buttons',
  templateUrl: './buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldButtonsComponent {
  @Input() buttons: IFormButtonUi[];

  constructor(
    private readonly dynamicFormService: DynamicFormService,
    private readonly hiddenService: HiddenService,
  ) {}

  isButtonHidden$(buttonName: string): Observable<boolean> {
    return this.hiddenService.isHidden$(buttonName);
  }

  handleButtonClick(button: IFormButtonUi): void {
    this.dynamicFormService.emitButtonClick(button);
  }
}
